export default "assets/images/fremoire-hero-bg-829d3903.svg";